import { ListItem } from '../p-field';

export class PMenuUtils {
    MAX_HEIGHT = 240;
    SMALL_HEIGHT = 96;
    MEDIUM_HEIGHT = 144;
    SINGLE_ITEM_HEIGHT = 36;
    SINGLE_BUTTON_HEIGHT = 32;
    EMPTY_STATE_HEIGHT = 100;

    calcHeight = (numOfGroups: number, numOfItems: number, emptyValueEnable: ListItem, useFullScreenHeight: boolean, numOfButtons = 0) => {
        if (numOfItems === 0) {
            return this.EMPTY_STATE_HEIGHT + (emptyValueEnable ? this.SINGLE_ITEM_HEIGHT : 0);
        }
        numOfItems += numOfGroups;
        if (emptyValueEnable) {
            numOfItems += 1;
        }
        const height = numOfItems * this.SINGLE_ITEM_HEIGHT;

        if (height > this.MAX_HEIGHT) {
            if (useFullScreenHeight) {
                const buttonsHeight = numOfButtons >= 1 ? numOfButtons * this.SINGLE_BUTTON_HEIGHT + 33 : 0;
                const fullCalclatedHeight = 0.7 * window.innerHeight - buttonsHeight;
                const calculatedHeight = height >= fullCalclatedHeight ? fullCalclatedHeight : height;
                return calculatedHeight;
            }

            if (window.innerHeight <= 480) {
                return this.SMALL_HEIGHT;
            } else if (window.innerHeight > 480 && window.innerHeight <= 720) {
                return this.MEDIUM_HEIGHT;
            } else {
                return this.MAX_HEIGHT;
            }
        }
        return height;
    };
}
